import { BaseElement, defineElement, html } from '@webtides/element-js';
import ShoppingCartEvents from '../../../structures/_shopping-cart/ShoppingCartEvents';

import '../../../structures/_shopping-cart/cart-leasing-modal/cart-leasing-modal';

class ShoppingCartPage extends BaseElement {
    checkoutBtns = null;

    connected() {
        this.checkoutBtns = this.querySelectorAll('[data-checkout-btn]');
        this.updateCart();
    }

    properties() {
        return {
            fetchingCart: false,
            cartObject: {},
            siteName: '',
            url: '',
            checkoutError: false,
        };
    }

    watch() {
        return {
            fetchingCart: fetchingCart => {
                this.setVisibilities({
                    loadingSpinner: !!fetchingCart,
                });
            },
        };
    }

    updateCart(force = false) {
        const { items, totalPrice, relatedProducts } = this.cartObject;

        const updateCartValues = () => {
            this.$refs.shoppingCart.items = items;
            // this.$refs.shoppingCart.totalPrice = totalPrice;
            this.$refs.shoppingCart.cart = this.cartObject;
        };

        if (force) {
            this.$refs.shoppingCart.items = [];
            this.$refs.shoppingCart.requestUpdate().then(updateCartValues);
        } else {
            updateCartValues();
        }

        const hasItems = items && items.length > 0;
        this.$refs.tabs.selected = hasItems ? 0 : 1;
        if (!this.checkoutError) {
            this.$refs.warningContent.classList.toggle('hidden', !this.cartObject?.tooManyBikes);
        }
        this.checkoutBtns.forEach(checkoutBtn => {
            checkoutBtn.toggleAttribute('disabled', !this.cartObject?.validForCheckout);
        });

        this.$refs.variantSlider.variants = relatedProducts ?? [];
        if (this.$refs.variantSlider.variants.length > 0) {
            this.$refs.productRecommendations.classList.remove('hidden');
        } else {
            this.$refs.productRecommendations.classList.add('hidden');
        }

        if (this.$refs.leasingModal) {
            const bikes = hasItems ? items.filter(item => item.bike === true) : [];
            this.$refs.leasingModal.product = bikes.length === 1 ? bikes[0] : null;
        }
    }

    events() {
        return {
            this: {
                [ShoppingCartEvents.ITEM_AMOUNT_INCREASE]: event => {
                    this.fetchCartByEvent(event);
                },
                [ShoppingCartEvents.ITEM_AMOUNT_DECREASE]: event => {
                    this.fetchCartByEvent(event);
                },
                [ShoppingCartEvents.ITEM_REMOVE]: event => {
                    this.fetchCartByEvent(event);
                },
                [ShoppingCartEvents.CART_CHANGED]: event => {
                    // set synced flag to false
                    // to hide initial error state from any CheckoutStep
                    this.checkoutError = false;
                    //update Card
                    this.updateCart();
                },
                [ShoppingCartEvents.CART_CHANGED_ERROR]: event => {
                    //forece update Card to reset amounts
                    this.updateCart(true);
                },
                [ShoppingCartEvents.DISCOUNT_ADD]: event => {
                    this.fetchCartByEvent(event);
                },
                [ShoppingCartEvents.DISCOUNT_REMOVE]: () => this.fetchCartByEvent(event),
            },
            '[data-checkout-btn]': {
                click: () => {
                    this.checkoutBtns.forEach(checkoutBtn => {
                        location.replace(checkoutBtn.getAttribute('href'));
                    });
                },
            },
        };
    }

    getApiUrl(type, sku, discountCode = '') {
        if (type === ShoppingCartEvents.ITEM_REMOVE) {
            return `${this.url}/remove/${this.siteName}?sku=${sku}`;
        } else if (type === ShoppingCartEvents.ITEM_AMOUNT_INCREASE) {
            return `${this.url}/increase/${this.siteName}?sku=${sku}`;
        } else if (type === ShoppingCartEvents.ITEM_AMOUNT_DECREASE) {
            return `${this.url}/decrease/${this.siteName}?sku=${sku}`;
        } else if (type === ShoppingCartEvents.DISCOUNT_ADD) {
            return `${this.url}/addDiscount/${this.siteName}?discount=${discountCode}`;
        } else if (type === ShoppingCartEvents.DISCOUNT_REMOVE) {
            return `${this.url}/removeDiscount/${this.siteName}?discount=${discountCode}`;
        }
    }

    fetchCartByEvent(event) {
        if (this.fetchingCart === true) return;
        this.fetchingCart = true;

        const type = event.type;
        const { id, discountCode } = event.detail;
        const url = this.getApiUrl(type, id, discountCode);

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                this.cartObject = response.cart;
                this.dispatch(ShoppingCartEvents.CART_CHANGED, response.cart, true, false, true);
            })
            .catch(error => {
                console.error(error);
                this.dispatch(ShoppingCartEvents.CART_CHANGED_ERROR, error, true);
            })
            .finally(() => {
                requestAnimationFrame(() => {
                    //wait a frame before unlocking the ui tp prevent racing fetches
                    this.fetchingCart = false;
                });
            });
    }

    setVisibilities(visibilities) {
        Object.entries(visibilities).forEach(([key, visibility]) => {
            if (!this.$refs[key]) {
                console.log('missing', key);
            }
            if (visibility === true) {
                this.$refs[key].classList.remove('hidden');
            } else {
                this.$refs[key].classList.add('hidden');
            }
        });
    }
}

defineElement('shopping-cart-page', ShoppingCartPage);
